export function hasDefaultValidatorParams(item) {
    return item?.message || item?.translationCode;
}
export function hasCondition(item) {
    return item?.condition && typeof item.condition === "function";
}
//# sourceMappingURL=validationRules.js.map